/** Карточка с графиком, растянутым на всю ширину. */
import type { ReactNode } from "react";
import { Card, Typography } from "antd";
import { ResponsiveContainer } from "recharts";

export function ChartCard({
  title,
  hint,
  children,
  height = 260,
}: {
  title: string;
  hint?: string;
  children: ReactNode;
  height?: number;
}) {
  return (
    <Card size="small" title={title} extra={hint && <Typography.Text type="secondary">{hint}</Typography.Text>}>
      <div style={{ width: "100%", height }}>
        <ResponsiveContainer>{children as React.ReactElement}</ResponsiveContainer>
      </div>
    </Card>
  );
}
